import React from 'react';
import styled from 'styled-components';

// 사이즈별 스타일 상수
const SIZES = {
  small: {
    size: '16px',
    gap: '8px',
    checkWidth: '3px',
    checkHeight: '5px',
    className: 'captionRegular',
  },
  regular: {
    size: '20px',
    gap: '8px',
    checkWidth: '4px',
    checkHeight: '7px',
    className: 'body2Medium',
  },
  large: {
    size: '24px',
    gap: '16px',
    checkWidth: '5px',
    checkHeight: '9px',
    className: 'body1Medium',
  },
};

// 색상 상수
const COLORS = {
  primary: 'var(--Primary-500)',
  disabled: '#BDB4FE',
  border: '#DDD',
  white: '#fff',
};

const CheckBox = ({
  size = 'large',
  name = '',
  label = '',
  checked = false,
  onChange = () => {},
  isDisabled = false,
  variant = 'default',
  onClick = () => {},
  className = '',
  style = {},
}) => {
  const sizeStyle = SIZES[size];

  return (
    <div
      className={`displayFlex ${className}`}
      style={{ gap: sizeStyle.gap, ...style }}
      onClick={e => {
        // e.stopPropagation();
        onClick();
      }}>
      <CheckboxContainer disabled={isDisabled} onClick={e => e.stopPropagation()}>
        <CheckboxInput
          type="checkbox"
          name={name}
          checked={checked}
          onChange={e => {
            e.stopPropagation();
            onChange(e);
          }}
          disabled={isDisabled}
        />
        <CheckboxCheckmark sizeStyle={sizeStyle} checked={checked} variant={variant} />
      </CheckboxContainer>
      {label && (
        <Label
          onClick={e => {
            e.stopPropagation();
            onChange({ target: { name: name } });
          }}
          className={sizeStyle.className}>
          {label}
        </Label>
      )}
    </div>
  );
};

export default CheckBox;

const shouldForwardProp = prop =>
  !['variant', 'color', 'size', 'isDisabled', 'sizeStyle', 'checked'].includes(prop);

const CheckboxContainer = styled.label.withConfig({ shouldForwardProp })`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  border-radius: 2px;
`;

const CheckboxInput = styled.input.withConfig({ shouldForwardProp })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  display: none;
`;

const getVariantStyle = variant => {
  if (variant === 'default') {
    return '2px';
  } else if (variant === 'circle') {
    return '50%';
  }
};

const getDisabledStyle = (isDisabled, checked) => {
  if (isDisabled) {
    if (checked) {
      return `
        background-color: ${COLORS.disabled};
        border-color: ${COLORS.disabled};
      `;
    } else {
      return `
      background-color: ${COLORS.primary};
      border-color: ${COLORS.primary};
    `;
    }
  } else {
    if (checked) {
      return `
        background-color: ${COLORS.primary};
        border-color: ${COLORS.primary};
      `;
    }
    return `
      background-color: ${COLORS.white};
      border-color: ${COLORS.border};
    `;
  }
};

const CheckboxCheckmark = styled.span.withConfig({ shouldForwardProp })`
  display: inline-block;
  width: ${({ sizeStyle }) => sizeStyle.size};
  height: ${({ sizeStyle }) => sizeStyle.size};
  border-radius: ${({ variant }) => getVariantStyle(variant)};

  border: 1px solid;
  position: relative;
  transition: all 0.2s ease-in-out;

  ${({ checked, isDisabled }) => getDisabledStyle(isDisabled, checked)}

  &:after {
    content: '';
    position: absolute;
    display: ${({ checked }) => (checked ? 'block' : 'none')};
    left: 50%;
    top: 45%;
    width: ${({ sizeStyle }) => sizeStyle.checkWidth};
    height: ${({ sizeStyle }) => sizeStyle.checkHeight};
    border: solid ${COLORS.white};
    border-width: 0 2px 2px 0;
    transform: translate(-50%, -50%) rotate(45deg);
    transition: all 0.2s ease-in-out;
  }

  ${CheckboxInput}:disabled + & {
    cursor: not-allowed;
    background-color: ${({ checked }) => (checked ? COLORS.disabled : COLORS.white)};
    border-color: ${({ checked }) => (checked ? COLORS.disabled : COLORS.border)};
  }
`;

const Label = styled.p`
  margin: 0;
  // font-family: Pretendard;
  // font-size: 16px;
  // font-style: normal;
  // font-weight: 500;
  // line-height: 24px;

  white-space: pre-wrap;
`;
